import type { IncidentType } from '@/types';

const getEarliestStartPeriod = (periods: IncidentType['activePeriod']): number => {
  if (!periods?.length) {
    return Number.MAX_SAFE_INTEGER;
  }

  return periods.reduce((earliest, { start }) => {
    const time = new Date(start).getTime();

    if (!Number.isNaN(time) && time < earliest) {
      return time;
    }

    return earliest;
  }, Number.MAX_SAFE_INTEGER);
};

export default getEarliestStartPeriod;
